export default __webpack_public_path__ + "static/media/video-1.02742410.mp4";